/**
 * 主题导出入口
 */

export { classicBlueTheme } from './classicBlue';
export { modernDarkTheme } from './modernDark';

import { classicBlueTheme } from './classicBlue';
import { modernDarkTheme } from './modernDark';

export const themes = {
  classic: classicBlueTheme,
  dark: modernDarkTheme
};

export default themes;
